import { render } from "./MusicLibraryFolder.vue?vue&type=template&id=53872886&scoped=true&ts=true"
import script from "./MusicLibraryFolder.vue?vue&type=script&lang=ts"
export * from "./MusicLibraryFolder.vue?vue&type=script&lang=ts"

import "./MusicLibraryFolder.vue?vue&type=style&index=0&id=53872886&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53872886"]])

export default __exports__